(() => {
  if (window.__ga4ScrollTrackingInitialized) return;
  if (typeof window.trackGA4Event !== 'function') return;

  window.__ga4ScrollTrackingInitialized = true;

  const scrollThresholds = Array.from({ length: 10 }, (_, index) => (index + 1) * 10);
  const trackedScrollThresholds = new Set();
  const scrollCheckInterval = 100;
  let scrollCheckTimeout = null;

  const getScrollPercentage = () => {
    const documentElement = document.documentElement;
    const body = document.body;
    const viewportHeight = window.innerHeight || documentElement.clientHeight || 0;
    const documentHeight = Math.max(
      documentElement.scrollHeight,
      documentElement.offsetHeight,
      documentElement.clientHeight,
      body?.scrollHeight || 0,
      body?.offsetHeight || 0,
      body?.clientHeight || 0,
    );
    const scrollableHeight = documentHeight - viewportHeight;

    if (scrollableHeight <= 0) return 0;

    const scrollTop =
      window.scrollY ||
      window.pageYOffset ||
      document.scrollingElement?.scrollTop ||
      documentElement.scrollTop ||
      0;

    if (scrollTop + viewportHeight >= documentHeight - 1) return 100;

    return Math.min(100, Math.floor((scrollTop / scrollableHeight) * 100));
  };

  const trackScrollDepth = () => {
    if (trackedScrollThresholds.size === scrollThresholds.length) return;

    const scrollPercentage = getScrollPercentage();

    scrollThresholds.forEach((threshold) => {
      if (scrollPercentage < threshold || trackedScrollThresholds.has(threshold)) return;

      trackedScrollThresholds.add(threshold);
      window.trackGA4Event({
        event_name: `scroll_${threshold}`,
        event_parameters: {
          current_page: window.location.href,
        },
      });
    });

    if (trackedScrollThresholds.size === scrollThresholds.length) {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('scrollend', handleScrollEnd);
    }
  };

  const handleScroll = () => {
    if (scrollCheckTimeout !== null) return;

    // Time-based sampling avoids reading page geometry on every animation frame.
    scrollCheckTimeout = window.setTimeout(() => {
      scrollCheckTimeout = null;
      trackScrollDepth();
    }, scrollCheckInterval);
  };

  const handleScrollEnd = () => {
    if (scrollCheckTimeout === null) return;

    window.clearTimeout(scrollCheckTimeout);
    scrollCheckTimeout = null;
    trackScrollDepth();
  };

  const initScrollTracking = () => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    document.addEventListener('scrollend', handleScrollEnd);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollTracking, { once: true });
  } else {
    initScrollTracking();
  }
})();
